<template>
  <div id="Enterprise">
    <el-form ref="form" :model="form" label-width="100px" size="medium">
      <div
        class="register-item"
        v-for="(item, index) of inputList"
        :key="index"
      >
        <el-form-item :label="item.name" :required="item.need ? true : false">
          <el-input
            :placeholder="item.placeholder"
            v-if="item.type === 'input'"
            v-model="form[item.model]"
          >
            <div slot="suffix" class="slot-code" v-show="item.code">
              |&nbsp;&nbsp;获取验证码
            </div>
          </el-input>
          <el-upload
            v-if="item.type === 'upload'"
            class="upload-demo"
            ref="upload"
            :action="$common.BASE_URL + '/hdweb/portal/uploadBusi'"
            :before-upload="beforeUpload"
            :on-remove="removeChange"
            :on-change="changeImg"
            :on-success="success"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
            <div slot="tip" class="el-upload__tip">上传营业执照</div>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>
    <div class="btn-box">
      <div @click="submitForm">注册</div>
      <div><router-link to="/" style="color:inherit">取消</router-link></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Enterprise',
  data () {
    return {
      inputList: [
        { name: '企业名称', placeholder: '请填写与营业执照上的名称', type: 'input', need: true, model: 'bName' },
        { name: '企业性质', placeholder: '请填写企业性质', type: 'input', need: true, model: 'bProperties' },
        { name: '企业地址', placeholder: '请填写企业地址', type: 'input', need: true, model: 'bAddress' },
        { name: '法人姓名', placeholder: '请填写法人姓名', type: 'input', need: true, model: 'legalPerson' },
        { name: '法人身份证', placeholder: '法人身份证号码', type: 'input', need: true, model: 'idcard' },
        { name: '所属辖区', placeholder: '请填写所属辖区', type: 'input', need: true, model: 'jurisdiction' },
        { name: '船舶数量', placeholder: '请填写船舶数量', type: 'input', need: true, model: 'ships' },
        { name: '驾驶员数量', placeholder: '请填写驾驶员数量', type: 'input', need: true, model: 'drivers' },
        { name: '主营业务', placeholder: '请填写主营业务', type: 'input', need: true, model: 'qualification' },
        { name: '联系方式', placeholder: '请填写联系方式', type: 'input', need: true, model: 'contact' },
        { name: '营业执照', placeholder: '', need: true, type: 'upload', model: 'files' }
        // {name: '密码', placeholder: '密码', need: true, model: 'passwd', type: 'input'},
        // {name: '城市', placeholder: '密码', need: true, model: 'passwd', type: 'upload'},
        // {name: '用户登录名', placeholder: '请填写与营业执照上的名称', need: true},
        // {name: '登录密码', placeholder: '请填写与营业执照上的名称', need: true},
        // {name: '确认密码', placeholder: '请填写与营业执照上的名称', need: true},
        // {name: '手机号', placeholder: '请输入手机号', need: true, code: true},
        // {name: '验证码', placeholder: '请填写与营业执照上的名称', need: true}
      ],
      busiCertArr: [],
      form: {
        files: '',
        bName: '',
        bProperties: '',
        bAddress: '',
        legalPerson: '',
        idcard: '',
        jurisdiction: '',
        ships: '',
        drivers: '',
        qualification: '',
        contact: ''
      },
      // loading 对象
      loading: ''
    }
  },
  methods: {
    /**
     * 上传成功
     */
    success (response, file, fileList) {
      this.loading.close()
      if (response.code === 0) {
        this.$message.success(response.msg)
        this.busiCertArr = fileList
        // this.busiCertArr.push(response.data)
        // this.form.videoUrl =
      } else {
        this.$message.error(response.msg)
      }
    },
    changeImg (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        // console.log(this.$refs.upload[0])
        // if (this.$refs.upload[0]) {
        //   this.$refs.upload[0].clearFiles()
        // }
        this.form.files = file.raw
      }
    },
    error (err) {
      this.loading.close()
      console.log(err)
      this.$message.error('网络错误上传失败')
    },
    /**
     * 上传之前判断文件类型
     */
    beforeUpload (file) {
      this.loading = this.$loading({
        lock: true,
        text: '上传文件中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      console.log(file)
      // let fileType = ['video/mp4', 'video/x-matroska']
      // if (!fileType.includes(file.type)) {
      //     this.$message.error('请上传视频格式文件')
      //     return false
      // }
    },
    removeChange (file, fileList) {
      // console.log(file)
      this.busiCertArr = fileList
      this.form.files = ''
    },
    submitForm () {
      const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!this.form.bName) {
        this.$message.error('请填写公司名称')
        return false
      } else if (!this.form.bProperties) {
        this.$message.error('请填写企业性质')
        return false
      } else if (!this.form.bAddress) {
        this.$message.error('请填写企业地址')
        return false
      } else if (!this.form.legalPerson) {
        this.$message.error('请填写法人姓名')
        return false
      } else if (!this.form.idcard) {
        this.$message.error('请填写法人身份证')
        return false
      } else if (!this.form.jurisdiction) {
        this.$message.error('请填写所属辖区')
        return false
      } else if (!this.form.ships) {
        this.$message.error('请填写船舶数量')
        return false
      } else if (!this.form.drivers) {
        this.$message.error('请填写驾驶员数量')
        return false
      } else if (!regIdCard.test(this.form.idcard)) {
        this.$message.error('法人身份证号码不正确')
        return false
      } else if (!this.form.qualification) {
        this.$message.error('请填写主营业务')
        return false
      } else if (!this.form.contact) {
        this.$message.error('请填写联系方式')
        return false
      } else if (this.form.files === '' || this.form.files == null) {
        this.$message.error('请上传营业执照')
        return false
      }
      // console.log(this.busiCertArr)
      let formData = new FormData()
      Object.keys(this.form).forEach(ele => {
        formData.append(ele, this.form[ele])
      })
      formData.append('phoneNumber', localStorage.getItem('phoneNumber'))
      this.$common.postCom(this.$common.BASE_URL_COM + '/hdplatform/app/saveBussiness', formData).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
          this.$store.dispatch('getUser')
          this.$router.push('/')
          setTimeout(function() {
            location.reload()
          }, 500)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
#Enterprise {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  padding-top: 25px;
  .el-form {
    width: 800px;
  }
  .register-item {
    width: 50%;
    display: inline-block;
    .slot-code {
      line-height: 40px;
      cursor: pointer;
      color: black;
    }
  }

  .btn-box {
    padding-left: 57px;
    display: flex;
    margin-top: 25px;

    > div {
      width: 80px;
      height: 34px;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      margin-right: 15px;

      &:hover {
        background: rgba(5, 160, 130, 1);
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/Enterprise.vue